import React from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Calendar } from "lucide-react"; 
import "../assets/css/Custom.css";

const CustomDatePicker = React.forwardRef(
  ({ placehold, value, onClick, onChange, label, className, customDateWrapper, isInvalid ,star}, ref) => (
    <div style={{ width: "100%", marginTop: "-20px" }} className={`${customDateWrapper}`}>
      {label && (
        <label
          className="form-label fw-bold"
          style={{ fontSize: "12px", lineHeight: "14.52px" }}
        >
          {label} <span>{star}</span>
        </label>
      )}
      <div style={{ position: "relative", width: "100%" }}>
        <input
          type="text"
          ref={ref}
          onClick={onClick}
          onChange={onChange} 
          className={`form-control border rounded custom-input ${className || "datepicker-border"}`}
          placeholder={!value ? placehold : ""}
          value={value || ""}
          style={{
            width: "100%",
            padding: "10px",
            fontSize: "15px",
            border: "2px solid",
            borderRadius: "4px",
            paddingRight: "40px",
          }}
        />
        <Calendar
          size={20}
          style={{
            position: "absolute",
            right: isInvalid ? "35px" : "10px",
            top: "50%",
            transform: "translateY(-50%)",
            cursor: "pointer",
            color: "#6c757d",
          }}
          onClick={onClick}
        />
      </div>
    </div>
  )
);


export default CustomDatePicker;
